// TODO: move this file to common api!

angular.module('zc.zenclerkS')
  .factory('AgencyUser', AgencyUser);

AgencyUser.$inject = ['$q', 'Api'];
function AgencyUser($q, Api) {
  const service = {
    all,
    create,
    destroy
  };

  return service;

  function all(agencyId) {
    return Api.get(`/api/agencies/${agencyId}/users`, {}, {cache: false})
      .then(function(res) {
        if(!res.data.success) {
          return $q.reject(res);
        }
        return res.data.users;
      });
  }

  function create(agencyId, user) {
    return Api.post(`/api/agencies/${agencyId}/users/`, { user })
      .then(function(res) {
        if(!res.data.success) {
          return $q.reject(res);
        }
        return res.data.user;
      });
  }


  function destroy(agencyId, id) {
    return Api.delete(`/api/agencies/${agencyId}/users/${id}`)
      .then(function(res) {
        if(!res.data.success) {
          return $q.reject(res);
        }
        return res.data.user;
      });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/agency_user.service.js